/**
 * useThemeCSSVariables Hook
 * 
 * Manages CSS custom properties for theme colors
 * This hook handles the side effects of applying theme values to the DOM
 */

import { useEffect } from 'react';
import { ThemeColors } from './useThemeColors';

export interface UseThemeCSSVariablesProps {
  colors: ThemeColors;
  titleColorOverride?: string | null;
  bodyColorOverride?: string | null;
  mounted: boolean;
}

export const useThemeCSSVariables = ({
  colors,
  titleColorOverride,
  bodyColorOverride,
  mounted
}: UseThemeCSSVariablesProps): void => {
  useEffect(() => {
    if (!mounted) return;

    const root = document.documentElement;
    
    // Apply text color overrides (if set), otherwise use theme defaults
    const finalTitleColor = titleColorOverride || colors.title;
    const finalBodyColor = bodyColorOverride || colors.body;
    
    // Update CSS variables
    root.style.setProperty('--bg-light', colors.background);
    root.style.setProperty('--bg-dark', colors.background);
    root.style.setProperty('--text-title', finalTitleColor);
    root.style.setProperty('--text-body', finalBodyColor);
    root.style.setProperty('--card-bg', colors.card);
    root.style.setProperty('--border-color', colors.border);
    root.style.setProperty('--muted-color', colors.muted);
  }, [mounted, colors, titleColorOverride, bodyColorOverride]);
};

